<script>
  import TextInputField from "./Fields/TextInputField.svelte";
  import CheckboxField from "./Fields/CheckboxField.svelte";
  import { onMount } from "svelte";
  import Markdown from "../Markdown.svelte";

  export let fieldType;
  export let fieldProps;
  export let error;
  export let uniqueId;
  let errorLabelId = `${fieldProps?.id}-${uniqueId}-error-message`;

  const FIELD_COMPONENT_MAP = {
    textInputField: TextInputField,
    checkboxField: CheckboxField
  };

  const component = FIELD_COMPONENT_MAP[fieldType];

  let binding;
  let width = 250;

  onMount(() => {
    if (binding?.clientWidth) {
      width = binding.clientWidth;
    }
  });
</script>

<!-- we set on:change explicitly here because it allows the parent component to read the change event  -->
<svelte:component
  this={component}
  {error}
  {errorLabelId}
  on:change
  on:clear
  {...fieldProps}
  bind:binding
/>
{#if error}
  <!-- set width and whitespace to allow the error text to overflow if needed  -->
  <div style:width="{width}px" class="relative text-size-12 mt-8 whitespace-normal">
    <Markdown class="!text-error" id={errorLabelId} input={error} />
  </div>
{/if}
{#if fieldProps.fieldDetailsRichText}
  <div class="text-size-14 mt-16">
    <Markdown input={fieldProps.fieldDetailsRichText} />
  </div>
{/if}
